import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Icon from '../components/Icon';
import PageHero from '../components/PageHero';

const NotFound = ({
  title = 'Page not found',
  message = "The page you're looking for doesn't exist or has moved.",
  backTo = '/',
  backLabel = 'Back to home',
}) => (
  <div className="not-found">
    <SEO title={title} description={message} noindex={true} />
    <PageHero eyebrow="Error 404" title={title} subtitle={message} align="center">
      <div className="btn-row" style={{ justifyContent: 'center', marginTop: 40 }}>
        <Link to={backTo} className="btn btn-primary btn-large">
          <Icon name="arrowLeft" />
          {backLabel}
        </Link>
      </div>
    </PageHero>
  </div>
);

export default NotFound;
